import { Search, CheckCircle2, Star } from "lucide-react";

const STEPS = [
  {
    number: "01",
    Icon: Search,
    title: "Tell us what you need",
    description: "Search by service type and location. Browse verified helper profiles with real photos, ratings, and reviews.",
  },
  {
    number: "02",
    Icon: CheckCircle2,
    title: "Book in minutes",
    description: "Pick your preferred helper, choose a date and time, then confirm your booking securely on the platform.",
  },
  {
    number: "03",
    Icon: Star,
    title: "Relax & rate",
    description: "Your verified helper arrives on time. Pay securely via MTN MoMo or Airtel Money. Then leave a review.",
  },
];

export function HowItWorksSimple() {
  return (
    <section className="py-5 md:py-10 sm:py-14 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-3 bg-primary/10 text-red-700 dark:text-primary border border-primary/20">
            Simple 3-step process
          </div>
          <h2 className="h-page text-foreground leading-tight">How it works</h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-xs mx-auto">Book a trusted helper in minutes. No guesswork, no stress.</p>
        </div>

        <div className="relative">
          <div className="hidden sm:block absolute top-14 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-border to-transparent" style={{ margin: '0 12.5%' }} />

          <div className="flex flex-col sm:flex-row gap-5 sm:gap-4">
            {STEPS.map((step, idx) => (
              <div key={step.number} className="flex-1 relative">
                {idx < STEPS.length - 1 && (
                  <div className="sm:hidden absolute left-7 top-16 w-0.5 h-5 bg-border" />
                )}

                <div className="rounded-2xl p-5 border border-border/60 bg-card card-shadow">
                  <div className="flex items-center gap-3 mb-4 sm:flex-col sm:items-center sm:gap-2 sm:text-center">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 bg-primary/10 text-primary">
                      <step.Icon className="w-6 h-6" />
                    </div>
                    <div className="flex items-center gap-1.5 sm:justify-center">
                      <span className="text-xs font-black uppercase tracking-widest text-primary">
                        STEP {step.number}
                      </span>
                    </div>
                  </div>

                  <div className="sm:text-center">
                    <h3 className="text-base font-bold text-foreground mb-1.5 leading-snug">{step.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="/booking-flow"
            /* The primary (clay) fill in both themes. It was a navy gradient
               from the pre-Kanfy palette in light mode (and near-invisible
               on the dark page). */
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-2xl bg-primary text-primary-foreground font-bold text-sm shadow-e2 hover:bg-primary/90 transition-colors"
          >
            Get Started Free
            <span className="text-base">&#8594;</span>
          </a>
        </div>
      </div>
    </section>
  );
}
